export const REMOVE_ORDER_PRODUCT = "REMOVE_ORDER_PRODUCT";
export const CLEAR_ORDER_PRODUCTS = "CLEAR_ORDER_PRODUCTS"